import { render } from "./PlatformDocuments.vue?vue&type=template&id=0962dfa7&scoped=true"
import script from "./PlatformDocuments.vue?vue&type=script&lang=js"
export * from "./PlatformDocuments.vue?vue&type=script&lang=js"

import "./PlatformDocuments.vue?vue&type=style&index=0&id=0962dfa7&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-0962dfa7"

export default script